import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styles from './Projects.module.css';

// Using our downloaded images as "project" showcase
const projects = [
  { img: 'svc3', title: 'Modern Exterior Cladding', location: 'Vancouver, BC', type: 'Cladding & Siding', year: '2024' },
  { img: 'svc2', title: 'Wood Frame Construction', location: 'Burnaby, BC', type: 'Framing', year: '2024' },
  { img: 'about', title: 'Commercial Renovation', location: 'Richmond, BC', type: 'Renovation', year: '2023' },
  { img: 'svc5', title: 'Rainscreen Waterproofing', location: 'North Vancouver, BC', type: 'Waterproofing', year: '2023' },
  { img: 'svc7', title: 'Stucco Remediation', location: 'Surrey, BC', type: 'Stucco Repair', year: '2024' },
  { img: 'svc8', title: 'Natural Stone Feature Wall', location: 'West Vancouver, BC', type: 'Natural Stone', year: '2023' },
];

const imgs = {
  svc2: require('../../assets/svc2.jpg'),
  svc3: require('../../assets/svc3.jpg'),
  svc5: require('../../assets/svc5.jpg'),
  svc7: require('../../assets/svc7.jpg'),
  svc8: require('../../assets/svc8.jpg'),
  about: require('../../assets/about.jpg'),
};

export default function Projects() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.06 });

  return (
    <section id="projects" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <motion.div
          className={styles.header}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <span className={styles.label}><span className={styles.labelLine} />Our Work</span>
          <h2 className={styles.heading}>
            Projects That <span className={styles.accent}>Speak for Themselves</span>
          </h2>
          <p className={styles.sub}>
            A selection of recent work across the Lower Mainland.
            Every project reflects our commitment to quality, craft, and client satisfaction.
          </p>
        </motion.div>

        <div className={styles.grid}>
          {projects.map((p, i) => (
            <motion.div
              key={p.title}
              className={`${styles.card} ${i === 0 ? styles.cardFeatured : ''}`}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.08 * i }}
            >
              <div className={styles.imgWrap}>
                <img src={imgs[p.img]} alt={p.title} className={styles.img} />
                <div className={styles.overlay}>
                  <span className={styles.overlayType}>{p.type}</span>
                  <h3 className={styles.overlayTitle}>{p.title}</h3>
                  <p className={styles.overlayLocation}>📍 {p.location}</p>
                </div>
              </div>
              <div className={styles.cardMeta}>
                <span className={styles.metaType}>{p.type}</span>
                <span className={styles.metaYear}>{p.year}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className={styles.note}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.7 }}
        >
          <span className={styles.noteIcon}>📸</span>
          <p>More project photos coming soon. <a href="#contact" onClick={e => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}>Contact us</a> to discuss your upcoming project.</p>
        </motion.div>
      </div>
    </section>
  );
}
